var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"water-level-chart"}},[_c('div',{staticClass:"water-level-chart-title"},[_vm._v("今日计划完成量")]),_vm._m(0),_c('div',{staticClass:"chart-container"},[_c('dv-water-level-pond',{attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-level-chart-details"},[_vm._v("累计完成"),_c('span',[_vm._v("1206")]),_vm._v("件")])
}]

export { render, staticRenderFns }